import { render, staticRenderFns } from "./AttachMessage.vue?vue&type=template&id=75320bb6&scoped=true&lang=pug&"
import script from "./AttachMessage.vue?vue&type=script&lang=js&"
export * from "./AttachMessage.vue?vue&type=script&lang=js&"
import style0 from "./AttachMessage.vue?vue&type=style&index=0&id=75320bb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75320bb6",
  null
  
)

export default component.exports